import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Checkbox,
    Chip,
    Grid2,
    IconButton,
    Tooltip,
    Typography,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import log from "loglevel";
import React, { useEffect, useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { lighten } from "@mui/system";
import ContactDropdown from "../common/Contacts";
import Select from "../common/Select";

import AccordionActions from "@mui/material/AccordionActions";
import Divider from "@mui/material/Divider";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditIcon from "@mui/icons-material/Edit";
import LinkIcon from "@mui/icons-material/Link";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import Skeleton from "@mui/material/Skeleton";
import classnames from "classnames";
import clsx from "clsx";
import TextAreaEditor from "components/common/TextAreaEditor";
import { actions } from "components/film/logic/filmFormActions";
import { assertArray, assertObject } from "core/validation";
import { get } from "lodash";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import FilmReleaseService from "services/filmReleaseService";
import { DATE_FORMAT_TEXT_INPUT, formatDate } from "components/common/dateUtils";
import { ExpandLess } from "@mui/icons-material";
import { FILM_RELEASE_ACTIONS_TYPES } from "../../core/dataConstants";
import AtsTooltip from "../common/AtsTooltip";
import { currentUserSelector } from "../login/logic/actions";
import { isReadOnlyRole } from "../login/logic/sagas";

export function getContentByFilmRelease(filmRelease, ratingReason, rating) {
    const content = {};
    if (filmRelease) {
        content.title = filmRelease.title;
        content.releaseDate = filmRelease.releaseDate
            ? formatDate(filmRelease.releaseDate, DATE_FORMAT_TEXT_INPUT)
            : formatDate(filmRelease.enteredDate, DATE_FORMAT_TEXT_INPUT);
        content.company = filmRelease.companyId && filmRelease.companyId.title;
        content.releaseType = get(filmRelease.filmReleaseTypeId, "name", "");
        content.ratingReason = ratingReason || filmRelease.ratingReason;
        content.rating = rating || filmRelease.filmRatingTypeId.name;
        content.contacts = filmRelease.contacts;
        content.ratingCategory = filmRelease.ratingSubCategory
            ? filmRelease.ratingSubCategory
            : filmRelease.ratingCategory
                ? filmRelease.ratingCategory
                : null;
        return content;
    } else {
        return null;
    }
}
const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    button: {
        marginRight: theme.spacing(2),
        padding: 8,
    },
    panelSummary: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        width: "100%",
    },
    panelSummaryTitle: {
        display: "flex",
        flex: 1,
    },
    panelSummarySubTitle: {
        display: "flex",
        flex: 1,
    },
    panelSummaryContent: {
        display: "flex",
        flex: 1,
        paddingTop: 3,
    },
    plusBtn: {
        marginLeft: "20px",
        order: 2,
    },
    iconColor: {
        color: theme.palette.secondary.main,
    },
    exceptionChip: {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
    },
    exceptionIcon: {
        color: theme.palette.error.main,
    },
    actionsColumn: {
        width: 30,
        float: "left",
    },
    titleWithOptions: {
        float: "left",
        width: "calc(100% - 30px)",
    },
    noPaddingSummary: {
        paddingLeft: 0,
    },
    cardNPaddingSummary: {
        paddingLeft: 0,

        "& .MuiAccordionSummary-content": {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1.5),
        },
    },
    cardItem: {
        paddingTop: 10,
        paddingBottom: 10,
    },
    selectText: {
        "& .MuiAccordionSummary-root": {
            userSelect: "auto",
        },
    },
}));

export function FilmCardSkeleton() {
    const classes = useToolbarStyles();
    return (
        (<div className={classes.panelSummary}>
            <Grid2 container>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 8,
                        lg: 6,
                        xl: 6
                    }}>
                    <Typography style={{ fontWeight: 600 }}>
                        <Skeleton width="50%" height={25} />
                    </Typography>
                    <div className={classes.panelSummaryContent}>
                        <Skeleton width="50%" height={25} />
                    </div>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 4,
                        lg: 6,
                        xl: 6
                    }}>
                    <Typography>
                        <span>
                            <Skeleton width="50%" height={25} />
                        </span>
                        <span style={{ paddingLeft: 45 }}>
                            <Skeleton width="50%" height={25} />
                        </span>
                    </Typography>
                </Grid2>
            </Grid2>
        </div>)
    );
}

export function filmReleaseToCard(filmRelease) {
    const content = {
        title: "Film Title",
        releaseDate: "Release Date",
        company: "Company",
        contacts: [],
    };
    if (filmRelease) {
        log.debug(filmRelease);
        content.id = filmRelease.id;
        content.title = filmRelease.title;
        content.releaseDate = filmRelease.releaseDate ? formatDate(filmRelease.releaseDate, DATE_FORMAT_TEXT_INPUT) : "No not defined";
        content.company = filmRelease.companyId && filmRelease.companyId.title;
        content.releaseType = get(filmRelease, "filmReleaseTypeId.name", "");
        content.ratingReason = filmRelease.ratingReason;
        content.rating = get(filmRelease, "filmRatingTypeId.name", "");
        content.contacts = filmRelease.contacts;
    }
    return content;
}
export function FilmExpandHeader({
    content,
    selected,
    onSelect,
    onRemove,
    editable,
    renderFilm,
    listItem,
    onEditFilm,
    expandable = true,
    hideTitle,
    showRatingAlways,
}) {
    const [checked, setChecked] = useState(selected);
    const classes = useToolbarStyles();

    function onEdit(e) {
        e.stopPropagation();
        onEditFilm();
    }

    function handleOnChecked(e) {
        e.stopPropagation();
        const isChecked = !checked;
        setChecked(isChecked);
        onSelect(content.id, isChecked);
    }

    function handleOnRemove(e) {
        e.stopPropagation();
        onRemove(content.id);
    }

    const titleStyle = hideTitle ? {} : { paddingLeft: 16 };
    const showOptions = listItem && (!!onSelect || editable || !!onRemove);
    return (
        (<div className={classnames(classes.panelSummary, expandable ? "" : classes.cardItem)}>
            <Grid2 container>
                <Grid2
                    style={{ position: "relative" }}
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 8,
                        lg: 6,
                        xl: 6
                    }}>
                    {showOptions && (
                        <div className={classes.actionsColumn}>
                            {!!onSelect && (
                                <Checkbox
                                    style={{ padding: 2, marginLeft: 0 }}
                                    value={checked}
                                    onClick={(e) => e.preventDefault()}
                                    onChange={handleOnChecked}
                                    disableRipple
                                />
                            )}
                            {editable && (
                                <Tooltip title="Edit">
                                    <IconButton size="small" onClick={onEdit}>
                                        <ModeEditOutlineIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {!!onRemove && (
                                <Tooltip title="Remove from List ">
                                    <IconButton style={{ padding: 3 }} size="small" onClick={handleOnRemove}>
                                        <DeleteOutlineOutlinedIcon />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    )}
                    <div style={titleStyle} className={showOptions ? classes.titleWithOptions : ""}>
                        {!hideTitle && <Typography style={{ fontWeight: 600 }}>{content.title}</Typography>}
                        <div className={classes.panelSummaryContent}>
                            <Typography>
                                {content.releaseType}
                                { }
                                {content.rating && (
                                    <Chip
                                        style={{ marginLeft: 10 }}
                                        variant="outlined"
                                        size="small"
                                        color="black"
                                        label={content.rating}
                                    />
                                )}
                                {content.releaseYear && <span style={{ marginLeft: 10 }}>{content.releaseYear}</span>}
                            </Typography>
                        </div>
                    </div>
                </Grid2>
                <Grid2
                    paddingLeft={5}
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 4,
                        lg: 6,
                        xl: 6
                    }}>
                    <Typography>
                        <span>{content.company}</span>
                    </Typography>
                    <Grid2 sx={{ display: { md: "none", lg: "block", xl: "block", sm: "none", xs: "none" } }}>
                        {renderFilm && !showRatingAlways ? (
                            <div className={classes.panelSummarySubTitle}>
                                <Typography
                                    style={{ width: "90%", fontSize: 12, opacity: 0.8, height: 35, marginLeft: 0 }}
                                    className={"block-ellipsis-2-lines"}
                                >
                                    {content.ratingReason}
                                </Typography>
                            </div>
                        ) : (
                            <span />
                        )}
                    </Grid2>
                </Grid2>
                {showRatingAlways && (
                    <Grid2 size={12}>
                        <div className={classes.panelSummarySubTitle}>
                            <Typography
                                style={{ width: "90%", fontSize: 12, opacity: 0.8, height: 33 }}
                                className={"block-ellipsis-2-lines"}
                            >
                                {content.ratingReason}
                            </Typography>
                        </div>
                    </Grid2>
                )}
            </Grid2>
        </div>)
    );
}

FilmExpandHeader.propTypes = {
    content: PropTypes.object,
    selected: PropTypes.bool,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    editable: PropTypes.bool,
    renderFilm: PropTypes.bool,
    listItem: PropTypes.bool,
    onEditFilm: PropTypes.func,
    expandable: PropTypes.bool,
    hideTitle: PropTypes.bool,
    showRatingAlways: PropTypes.bool,
};


async function loadFilm(id) {
    const response = await FilmReleaseService.getFilmRelease(id);
    return response.data;
}

function FilmCardView({
    defaultExpanded = false,
    lazyLoad = true,
    editable = true,
    listItem = false,
    onSelect = null,
    renderDetails = null,
    showActions = true,
    showHistory = false,
    loadFilmReleaseId,
    onSelectFilmReleaseHistory,
    filmReleaseHistory,
    filmReleaseHistoryList,
    expandPanelClassName,
    filmReleaseFormOpen,
    ...props
}) {
    const classes = useToolbarStyles();
    const [expanded, setExpanded] = useState(defaultExpanded);
    const [expandedHistory, setHistoryExpanded] = useState(false);
    const content = {
        title: "Film Title",
        releaseDate: "Release Date",
        company: "Company",
        contacts: [],
        frHistory: []
    };



    const [_filmRelease, setFilmRelease] = useState(null);

    const filmRelease = lazyLoad ? _filmRelease : props.filmRelease;

    const [formIsOpen, setFormIsOpen] = useState(false);

    const user = useSelector(currentUserSelector);

    useEffect(() => {
        if (!lazyLoad) {
            return undefined;
        }
        let active = true;
        const canLoadFilmRelease = !filmRelease && loadFilmReleaseId;
        if (canLoadFilmRelease) {
            (async () => {
                if (loadFilmReleaseId) {
                    const filmR = await loadFilm(loadFilmReleaseId);
                    if (active) {
                        setFilmRelease(filmR);
                    }
                }
            })();
        }
        return () => {
            active = false;
        };
    }, []);

    useEffect(() => {
        if (expandedHistory) {
            setHistoryExpanded(false);
        }
    }, [filmRelease]);

    useEffect(() => {
        if (!lazyLoad) {
            return undefined;
        }
        let active = true;
        const formUpdated = formIsOpen && !filmReleaseFormOpen;
        const canLoadFilmRelease =
            (filmRelease && loadFilmReleaseId !== filmRelease.id) || (!filmRelease && loadFilmReleaseId);
        if (!loadFilmReleaseId) {
            setFilmRelease(null);
        }
        if (canLoadFilmRelease || formUpdated) {
            (async () => {
                if (loadFilmReleaseId) {
                    try {
                        const filmR = await loadFilm(loadFilmReleaseId);
                        if (active) {
                            setFilmRelease(filmR);
                        }
                    } catch (e) {
                        log.debug(e);
                    }
                }
            })();
        }
        setFormIsOpen(filmReleaseFormOpen);
        return () => {
            active = false;
        };
    }, [loadFilmReleaseId, filmReleaseFormOpen]);

    const renderFilm = assertObject(filmRelease);
    if (renderFilm) {
        if (filmReleaseHistoryList && filmReleaseHistoryList.length > 0) {
            let frHistory = filmReleaseHistoryList.find(historyItem => historyItem[0].entityId === filmRelease.id);
            if (frHistory) {
                content.frHistory = frHistory;
            }
            else content.frHistory = [];
        }
        else content.frHistory = [];
        (content.id = filmRelease.id), (content.title = filmRelease.title);
        content.releaseDate = filmRelease.releaseDate ? formatDate(filmRelease.releaseDate, DATE_FORMAT_TEXT_INPUT) : "Not defined";
        content.company = filmRelease.companyId && filmRelease.companyId.title ? filmRelease.companyId.title : filmRelease.company && filmRelease.company.title && filmRelease.company.title;
        content.releaseType = get(filmRelease, "filmReleaseTypeId.name", "") ? get(filmRelease, "filmReleaseTypeId.name", "") : get(filmRelease, "filmReleaseType.name", "") ? get(filmRelease, "filmReleaseType.name", "") : "";
        content.ratingReason = filmRelease.ratingReason;
        (content.rating = get(filmRelease, "filmRatingTypeId.name", "") ? get(filmRelease, "filmRatingTypeId.name", "") : get(filmRelease, "filmRatingType.name", "") ? get(filmRelease, "filmRatingType.name", "") : ""),
        (content.contacts = assertArray(filmRelease.contacts) ? filmRelease.contacts : []);
        content.enteredDate = filmRelease.enteredDate ? formatDate(filmRelease.enteredDate, DATE_FORMAT_TEXT_INPUT) : "Not defined";
        content.certifiedDate = filmRelease.ratingDate ? formatDate(filmRelease.ratingDate, DATE_FORMAT_TEXT_INPUT) : "Not defined";
        content.releaseYear = formatDate(filmRelease.enteredDate, DATE_FORMAT_TEXT_INPUT);
        content.ratingCategory = filmRelease.ratingSubCategory
            ? filmRelease.ratingSubCategory
            : filmRelease.ratingCategory
                ? filmRelease.ratingCategory
                : null;
    }

    const altTitles =
        filmRelease &&
        filmRelease.alternativeTitles &&
        filmRelease.alternativeTitles.map((t) => ({
            label: t.title,
            value: t.id,
        }));

    function onEditFilm() {
        props.toggleFilmReleaseForm(true, filmRelease.id);
    }
    function handleGoImbd() {
        const title = content.title.replace(/ /g, "+");
        const url = `https://www.imdb.com/find?q=${title}`;
        window.open(url);
    }
    const ratingReason = content.ratingReason || "";
    function handleExpand() {
        if (renderFilm) {
            setExpanded(!expanded);
        }
    }

    function handleExpandHistory() {
        if (renderFilm) {
            if (!expandedHistory) {
                onSelectFilmReleaseHistory(filmRelease);
            }
            setHistoryExpanded(!expandedHistory);
        }
    }

    const details = renderDetails ? (
        renderDetails()
    ) : (
        <Grid2 container direction={"column"} spacing={1}>
            <Grid2 container direction={"row"} spacing={2}>
                <Grid2 container spacing={4} size={{
                    md: 6
                }}>
                    {filmRelease && assertArray(filmRelease.alternativeTitles) && (
                        <Grid2 container spacing={2}
                            size={{
                                xs: 12,
                                lg: 10,
                                xl: 6
                            }}>
                            <span className={"atsSubtitleCar"}>Alternative Titles</span>
                            <Select
                                value={altTitles}
                                inputValue={""}
                                multiple
                                placeholder={assertArray(altTitles) ? "Alternative Titles" : "No Values"}
                                menuIsOpen={false}
                                defaultMenuPortalTarget

                            />
                        </Grid2>
                    )}

                    <Grid2 paddingLeft={2}
                        container
                        spacing={2}
                        size={{
                            xs: 12,
                            lg: 12,
                            xl: 6
                        }}>
                        <Grid2 size={12}>
                            <span className={"atsSubtitleCar"}>Release Date:</span>
                            <span className={"atsTitleCar"}>{content.releaseDate}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className={"atsSubtitleCar"}>Entered Date:</span>
                            <span className={"atsTitleCar"}>{content.enteredDate}</span>
                        </Grid2>
                        <Grid2 size={12}>
                            <span className={"atsSubtitleCar"}>Certified Date:</span>
                            <span className={"atsTitleCar"}>{content.certifiedDate}</span>
                        </Grid2>
                    </Grid2>
                    {assertArray(content.contacts) && (
                        <Grid2 paddingLeft={2} size={12}>
                            <span className={"atsSubtitleCar"}>Contacts </span>
                            <ContactDropdown options={content.contacts} />
                        </Grid2>
                    )}
                </Grid2>
                <Grid2 container direction={"column"} spacing={2} size={{
                    md: 6
                }}>
                    <Grid2>
                        <span className={"atsSubtitleCar"}>Release:</span>
                        <span className={"atsTitleCar"}>{content.releaseType}</span>
                        <span className={"atsSubtitleCar"} style={{ marginLeft: 15 }}>
                            Rating:
                        </span>
                        <span className={"atsTitleCar"}>{content.rating}</span>
                        {content.ratingCategory && <span className={"atsSubtitleCar"} style={{ marginLeft: 15 }}>
                            Rating Category:
                        </span>}
                        {content.ratingCategory && <span className={"atsTitleCar"}>{content.ratingCategory}</span>}
                    </Grid2>

                    {!listItem && (
                        <Grid2>
                            { }
                            <span className={"atsTitleCar"}>
                                <TextAreaEditor
                                    styles={{ maxHeight: 150, minHeight: 75 }}
                                    readOnly
                                    defaultValue={ratingReason}
                                />
                            </span>
                        </Grid2>
                    )}
                </Grid2>
                {showHistory && <Grid2 paddingLeft={2} size={12}>
                    <div>
                        <button onClick={handleExpandHistory} className={"atsFilmReleaseHistoryTitle"}>
                            <span className="atsSubtitleCar">
                                Release Edit History
                            </span>
                        </button>
                        <span style={{ position: "absolute", cursor: "pointer" }}>
                            {!expandedHistory ? <ExpandMoreIcon onClick={handleExpandHistory} /> : <ExpandLess onClick={handleExpandHistory} />}
                        </span>
                    </div>
                    {expandedHistory && filmReleaseHistory && <FilmEditHistory filmReleaseHistory={content.frHistory} filmReleaseHistoryList={filmReleaseHistoryList} />}
                </Grid2>}
            </Grid2>
        </Grid2>
    );
    const actions =
        showActions && content.title && !isReadOnlyRole(user) ? (
            <React.Fragment>
                <Divider />
                <AccordionActions>
                    <Grid2 container size={12}>
                        {editable && (
                            <Button
                                size="small"
                                style={{ marginRight: 20 }}
                                color="secondary"
                                onClick={onEditFilm}
                                startIcon={<EditIcon />}
                            >
                                Edit
                            </Button>
                        )}
                        <Button size="small" onClick={handleGoImbd} startIcon={<LinkIcon />}>
                            Go to IMDB
                        </Button>

                        { }
                    </Grid2>
                </AccordionActions>
            </React.Fragment>
        ) : null;
    return (
        <Accordion
            slotProps={{ transition: { unmountOnExit: true } }}
            className={clsx(expandPanelClassName, classes.selectText)}
            expanded={expanded && renderFilm}
            defaultExpanded={props.defaultExpanded}
            onChange={handleExpand}
            variant={listItem ? "outlined" : "elevation"}
        >
            <AccordionSummary className={classes.cardNPaddingSummary} expandIcon={<ExpandMoreIcon />}>
                <FilmExpandHeader
                    content={content}
                    renderFilm={renderFilm}
                    listItem={listItem}
                    selected={props.selected}
                    onSelect={onSelect}
                    editable={props.editable}
                    onRemove={props.onRemove}
                    onEditFilm={onEditFilm}
                />

                { }
                { }
                { }
            </AccordionSummary>

            <AccordionDetails>{details}</AccordionDetails>

            {actions}
        </Accordion>
    );
}

function FilmEditHistory({ filmReleaseHistory, filmReleaseHistoryList }) {
    const history = getHistory();

    function getHistory() {
        let historyChanges = filmReleaseHistory;
        if (historyChanges) {
            historyChanges.map(change => {
                if (typeof change.payload === "string") {
                    const payload = JSON.parse(change.payload);
                    Object.assign(change, { payload });
                }
            });
        }
        return historyChanges;
    }
    const items = history.length > 0 ? history.map((item, index) => {
        const action = Object.keys(FILM_RELEASE_ACTIONS_TYPES).find(action => action === item.action);
        const actionType = action ? FILM_RELEASE_ACTIONS_TYPES[action] : null;
        const showExtraData = item.payload?.sourceDto ? item.payload?.finalDto : false;
        const actionText = showExtraData ? `${item.payload?.sourceDto.title} ${actionType} ${showExtraData.title}`.toString() : "";
        return <Grid2 key={`${item.entityId}${index}`} paddingLeft={5} paddingRight={5} paddingBottom={2}>
            <Grid2 container columnSpacing={3}>
                {actionType && <Typography style={{ fontWeight: 600, paddingLeft: 2 }}>Action:</Typography>}
                {actionType && showExtraData ?
                    <AtsTooltip
                        trigger={
                            <Typography
                                style={{ fontSize: "1rem" }}
                                dangerouslySetInnerHTML={{ __html: actionText ? actionText.length > 50 ? actionText.substring(0, 50) + "..." : actionText : "" }}
                            />
                        }
                        content={
                            <React.Fragment>
                                <Typography
                                    className={"no-padding-html-text"}
                                    dangerouslySetInnerHTML={{ __html: actionText ? actionText : "" }}
                                />
                            </React.Fragment>
                        }
                        contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                    /> :
                    actionType && <Typography style={{ fontWeight: 400, paddingLeft: 3 }}>{actionType}</Typography>}
                <Typography style={{ fontWeight: 600, paddingLeft: 5 }}>User:</Typography>
                <Typography style={{ fontWeight: 400, paddingLeft: 3 }}>{item.createdBy.firstName} {item.createdBy.lastName}</Typography>
                <Typography style={{ fontWeight: 600, paddingLeft: 5 }}>Date:</Typography>
                <Typography style={{ fontWeight: 400, paddingLeft: 3 }}>{formatDate(item.dateEntered, DATE_FORMAT_TEXT_INPUT)}</Typography>
            </Grid2>
            <FilmCardView key={item.id} filmReleaseHistoryList={filmReleaseHistoryList} lazyLoad={false} filmRelease={item.payload.finalDto} showActions={false} editable={false} showHistory={false} />
        </Grid2>;
    }) :
        <Grid2 paddingLeft={5} paddingRight={5} paddingBottom={2}>
            <Grid2 container>
                <Typography style={{ fontWeight: 600 }}>No Edit History</Typography>
            </Grid2>
        </Grid2>;
    return (
        <Grid2>
            {items}
        </Grid2>
    );

}


export default connect(
    (state) => {
        return {
            filmReleaseFormOpen: state.filmReleaseForm.open,
            deleteStatus: state.filmReleaseForm.deleteStatus,
            filmReleaseHistoryList: state.filmReleaseList.frHistoryList
        };
    },
    (dispatch) => ({
        toggleFilmReleaseForm: (editing, id) => dispatch(actions.TOGGLE_FILM_RELEASE_FORM.send({ editing, id })),
    })
)(FilmCardView);
